import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
const userLang = localStorage.getItem('lang') || 'en';
i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: userLang,
  resources: {
    en: {
      translations: require('../locales/en/translation.json')
    },
    ta: {
      translations: require('../locales/ta/translation.json')
    }
  },
  ns: ['translations'],
  defaultNS: 'translations'
});

i18n.languages = ['en', 'ta'];

export default i18n;
